
import { Component, Prop, Vue } from 'vue-property-decorator';
import Question from "@/views/Questionnaire/Question";
import {UserFile} from "@/models/UserFile";
import {AxiosError} from "axios";
import ErrorHandler from "@/support/ErrorHandler";
import {User} from "@/models/User";
import {LeadFile} from "@/models/LeadFile";
import {BoxRequest} from "@/models/BoxRequest";
import {cloneDeep} from "lodash";

@Component<BlockImages>({
  components: {
    Question
  }
})
export default class BlockImages extends Vue {
  @Prop()
  private requestId!: string;

  @Prop()
  private images!: [];

  @Prop()
  private user!: User;

  private isAddingImages: boolean = false;

  private uploadFiles() : void
  {
    this.isAddingImages = true;
  }

  private deleteImage(mediaId: string) : void
  {
    (new UserFile())
      .deleteUserFile((this.user as any).id, mediaId)
      .then(() => {
        this.fetchFiles();
      })
      .catch((error: AxiosError) => {
        ErrorHandler.network(error);
      });
  }

  private get question()
  {
    return {
      type: 'upload-file',
      category: 'over_jou',
      title: "Foto's",
      text: 'Zou jij een paar foto’s van jezelf kunnen uploaden zodat de styliste een beter beeld van je krijgt?',
      key: 'upload-file_1',
    };
  }

  protected closeDialog() {
    if (this.isAddingImages) {
      this.isAddingImages = false;
    }
  }

  setImages(answer: any) {
    if (! this.user) {
      return;
    }

    const images: any[] = [];
    answer.value.forEach((image: any) => {
      images.push(image);
    });
    this.$emit("handleImageUpdate", images);

    let callCount = images.length;

    images.forEach((file: string) => {
      (new UserFile())
        .user((this.user as any).id)
        .create({ file })
        .then(() => {
          callCount -= 1;

          if (callCount <= 0) {
            this.fetchFiles();
          }
        })
        .catch((error: AxiosError) => {
          ErrorHandler.network(error);
        });
    });

    this.isAddingImages = false;
  }

  protected fetchFiles()
  {
    if (! this.requestId) { return; }
    new BoxRequest()
      .include(['images'])
      .find(this.requestId)
      .then(response => {
        this.images = response.images
      })
      .catch((error: AxiosError): null => {
        ErrorHandler.network(error);
        return null;
      });
  }
}
